module.exports = __webpack_public_path__ + "img/WALK-PERFORMANCE-05.3bb6ec35.png";